<div
  class="d-flex align-items-center justify-content-space-between mbm ea-gridky-header"
>
  <h4 class="fw-500 fs-16">
    Le bien le plus rentable pour votre profil investisseur
  </h4>
  <!-- <pr-button display="neutral" size="lg">Prendre rendez-vous</pr-button> -->
</div>

<!-- <div class="d-flex ea-griky-header-actions ea-griky-header-actions-area mbm">
  <button (click)="eaGridkyService.changeSelectedArea(GridkyAreas.around)"
    [class.active]="selectedArea == GridkyAreas.around">Autour de chez vous</button>
  <button (click)="eaGridkyService.changeSelectedArea(GridkyAreas.france)"
    [class.active]="selectedArea == GridkyAreas.france">France entière</button>
</div> -->

<!-- <div class="d-flex ea-griky-header-actions ea-griky-header-actions-types flex-wrap-md mbm" *ngIf="showTypeSelection">
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.ephad, true)"
    [class.active]="selectedType == GridkyType.ephad">Ephad</button>
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.student, true)"
    [class.active]="selectedType == GridkyType.student">Étudiant</button>
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.senior, true)"
    [class.active]="selectedType == GridkyType.senior">Senior</button>
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.tourism, true)"
    [class.active]="selectedType == GridkyType.tourism">Tourisme</button>
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.medical, true)"
    [class.active]="selectedType == GridkyType.medical">Médical</button>
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.business, true)"
    [class.active]="selectedType == GridkyType.business">Affaires</button>
  <button (click)="eaGridkyService.changeSelectedType(GridkyType.personal_residency)"
    [class.active]="selectedType == GridkyType.personal_residency">Résidentiel</button>
</div> -->

<!-- <ng-container *ngIf="!loading"
  [ngTemplateOutlet]="(!eaGridkyService.userRp && selectedArea== GridkyAreas.around) ? noUserRpTemplate : eaGridkyService.product ? productExistTemplate : productNotFoundTemplate">
</ng-container> -->

<ng-template #productExistTemplate>
  <h4 class="mbxs fw-600">
    {{
      selectedArea == GridkyAreas.around
        ? 'albR a sélectionné le bien à côté de chez vous le plus pertinent'
        : 'albR a sélectionné le bien le plus pertinent de France'
    }}
  </h4>
  <p class="text-secondary fw-400">
    Pour se faire, nous utilisons la technologie Gridky qui grâce à la BigData
    analyse et score tous les biens immobilier neufs en France de manière
    quotidienne et albR, notre intelligence artificielle determine votre montant
    d’investissement optimal en fonction de votre profil fiscal ainsi que de
    votre capacité d’emprunt.
  </p>
</ng-template>

<ng-template #productNotFoundTemplate>
  <h4 class="mbxs fw-600">
    {{
      selectedArea == GridkyAreas.around
        ? "albR a tenté de trouver le bien à côté de chez vous le plus pertinent mais n'a trouvé aucun résultat"
        : "albR a tenté de trouver le bien le plus pertinent en France mais n'a trouvé aucun résultat"
    }}
  </h4>
  <p class="text-secondary fw-400 mbl">
    Essayez de modifier les paramètres de simulation tel que le montant investit
    (valeur du bien), ou consultez les offres sur la
    <b
      class="pointer text-secondary underline"
      (click)="eaGridkyService.changeSelectedArea(GridkyAreas.france)"
      >France entière</b
    >
  </p>
  <pr-icon
    name="sp-mia_waiting"
    viewBoxWidth="47"
    viewBoxHeight="77.9"
    width="100"
    height="165"
    style="width: auto; justify-content: center"
  ></pr-icon>
</ng-template>

<ng-template #noUserRpTemplate>
  <h4 class="mbxs fw-600">
    Vous n'avez pas renseigné votre résidence principale
  </h4>
  <p class="text-secondary fw-400 mbl">
    Afin de nous permettre de localiser un bien prêt de chez vous, il vous faut
    renseigner l'adresse de votre résidence principale
  </p>

  <pr-icon
    name="sp-mia_notepad"
    viewBoxWidth="47"
    viewBoxHeight="77.9"
    width="100"
    height="165"
    style="width: auto; justify-content: center"
  ></pr-icon>
</ng-template>
